/**
 * Hermes/Expo TextDecoder solo soporta utf-8. jspdf (y deps) hacen
 * `new TextDecoder('latin1')` al cargar → crash antes del primer paint en Android.
 * Instalar DESPUÉS de importar `expo` y ANTES de `App`.
 */
const LEGACY = new Set([
  'latin1',
  'iso88591',
  'iso8859-1',
  'ascii',
  'usascii',
  'us-ascii',
  'binary',
]);

function normalizeLabel(label: string | undefined): string {
  return String(label ?? 'utf-8')
    .trim()
    .toLowerCase()
    .replace(/[_ ]+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
}

function toBytes(input?: BufferSource): Uint8Array {
  if (!input) return new Uint8Array();
  if (input instanceof ArrayBuffer) return new Uint8Array(input);
  return new Uint8Array(input.buffer, input.byteOffset, input.byteLength);
}

function decodeLatin1(bytes: Uint8Array): string {
  let out = '';
  for (let i = 0; i < bytes.length; i++) {
    out += String.fromCharCode(bytes[i]!);
  }
  return out;
}

export function installTextDecoderLatin1(): void {
  if (typeof globalThis === 'undefined') return;
  const Native = globalThis.TextDecoder;
  if (!Native) return;

  // Evitar doble wrap
  if ((Native as unknown as { __vueltoLatin1?: boolean }).__vueltoLatin1) return;

  class TextDecoderLatin1 {
    readonly encoding: string;
    readonly fatal: boolean;
    readonly ignoreBOM: boolean;
    private readonly inner: InstanceType<typeof Native> | null;
    private readonly legacy: boolean;

    constructor(label?: string, options?: TextDecoderOptions) {
      const normalized = normalizeLabel(label);
      this.legacy = LEGACY.has(normalized) || LEGACY.has(normalized.replace(/-/g, ''));
      this.fatal = Boolean(options?.fatal);
      this.ignoreBOM = Boolean(options?.ignoreBOM);
      if (this.legacy) {
        this.encoding = normalized.includes('ascii') ? 'ascii' : 'windows-1252';
        this.inner = null;
        return;
      }
      this.inner = new Native(label, options);
      this.encoding = this.inner.encoding;
    }

    decode(input?: BufferSource, options?: TextDecodeOptions): string {
      if (this.legacy) return decodeLatin1(toBytes(input));
      return this.inner!.decode(input, options);
    }
  }

  (TextDecoderLatin1 as unknown as { __vueltoLatin1: boolean }).__vueltoLatin1 = true;
  globalThis.TextDecoder = TextDecoderLatin1 as unknown as typeof TextDecoder;
}
